import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
// import Navbar from '../components/navbar/Navbar';
// add styles
import styles from './Footer.module.scss'
import Hamburger from '../hamburger/Hamburger';



const Footer = () => {


    const [showBackToTop, setShowBackToTop] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleScroll = () => {
        if (window.scrollY > 200) {
            setShowBackToTop(true);
        } else {
            setShowBackToTop(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };

    }, []);
    return (
        <footer>
            {showBackToTop && (
                <button className={styles.backToTop} onClick={scrollToTop}>
                    Back to Top
                </button>
            )}
            <div className={`${styles.footerNav}`}>
                <NavLink to="/" className={styles.navLink} style={({ isActive }) => ({
                    borderBottom: isActive ? '3px solid red' : '',
                })}>Home</NavLink>
                {/* 
                <NavLink to="about" className={styles.navLink} style={({ isActive }) => ({
                    borderBottom: isActive ? '3px solid red' : '',
                })}>About</NavLink> */}

                <NavLink to="blog" className={styles.navLink} style={({ isActive }) => ({
                    borderBottom: isActive ? '3px solid red' : '',
                })}>Blog</NavLink>

                {/* <NavLink to="todolist" className={styles.navLink} style={({ isActive }) => ({
                    borderBottom: isActive ? '3px solid red' : '',
                })}>Todo List</NavLink> */}

                {/* <Hamburger /> */}
            </div>
        </footer >
    )
}

export default Footer;